// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"priceFromMapCalculator_wrapper__1h-_2","infoText":"priceFromMapCalculator_infoText__1u2vF"};